import { Box, ButtonGroup, IconButton, Tooltip, Zoom } from "@material-ui/core";
import { Create, Send, AccountTree, AddToQueue, AssignmentReturn } from "@material-ui/icons";
import React, { useState } from "react";
import { useNotify, useRefresh } from "react-admin";
import { useHistory } from "react-router-dom";
import { DetailButton } from "../../../../Components/DetailButton";
import { ConfirmButton } from "../../../../Components/ConfirmButton";
import { useAppDataProvider } from "../../../../dataprovider";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import { useAccessControl, useAuth } from "@airborne/react-admin";
import { SourceRequestOrder } from "../../Constant/Source";
import RequestOrderReserveForm from "./RequestOrderReserveForm";
export const ListCustomButtons = props => {
  const refresh = useRefresh();
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const { user } = useAuth();
  const [reserveFormOpen, setReserveFormOpen] = useState(false);
  const { canCreate, canEdit, canRead, hasAccess } = useAccessControl(SourceRequestOrder);

  const onClick = () => {
    props.onEdit(props.record?.id, "/requestremarks/requestorders/", props.record);
  };
  const handleShowWorkflow = e => {
    props?.handleOpenWorkFlow?.(props?.record?.id);
  };
  const handleSendReplacementWaiting = () => {
    props.onEdit(false);
    dataProvider
      .getOne("requestorders/", {
        id: props.record.id,
      })
      .then(response => {
        response.data.requestStatus = RequestStatus.CancellationRepairPeriod;

        dataProvider
          .updateRequestOrder(response.data)
          .then(result => {
            notify(`Record Updated`, "success", false, true);
            refresh();
          })
          .catch(error => notify(`${error}`, "error", false, true));
      })
      .catch(error => {
        console.log(error);
      });
  };
  const handleReserveOpen = e => {
    setReserveFormOpen(true);
  };
  const onDetailClick = record => {
    props.onEdit(record?.id);
  };
  const DetailsButton = ({ record }) => {
    return <DetailButton record={record} resource={"requestorders"} onClick={onDetailClick} onClickDisabled={true} />;
  };

  const SendPreviousStatus = props => {
    return (
      <ConfirmButton
        {...props}
        variant="text"
        style={{ width: 40 }}
        size="medium"
        click={SendPreviousStatusButtonClick(props)}
      >
        <Tooltip TransitionComponent={Zoom} title="Send Previous Status">
          <AssignmentReturn />
        </Tooltip>
      </ConfirmButton>
    );
  };

  const SendPreviousStatusButtonClick = props => e => {
    dataProvider
      .getList("requesthistorys/", {
        pagination: { page: 1, perPage: 999 },
        sort: { field: "id", order: "DESC" },
        filter: {
          requestId__eq: props.record.id,
          requestStatus__neq: RequestStatus.CancellationRepairPeriod,
        },
      })
      .then(response => {
        var previousRecord = response.data.sort((a, b) => a.createdDate - b.createdDate)[0];
        dataProvider
          .getOne("requestorders/", {
            id: props.record.id,
          })
          .then(response => {
            response.data.requestStatus = previousRecord.requestStatus;
            dataProvider
              .updateRequestOrder(response.data)
              .then(result => {
                //history.push('/requestorders/' + result.data.id)
                history.go(0);
                notify(`Record Updated`, "success", false, true);
              })
              .catch(error => notify(`${error}`, "error", false, true));
          })
          .catch(error => {});
      })
      .catch(error => {});
  };

  return (
    <Box style={{ flex: 1, flexDirection: "row" }}>
      <RequestOrderReserveForm
        handleClose={setReserveFormOpen}
        open={reserveFormOpen}
        requestId={props?.record?.id}
        refNo={props?.record?.refNo}
      />
      <ButtonGroup variant="text" size="small">
        {!props?.detailButtonDisabled && <DetailsButton {...props} />}
        {user?.isCustomer === false && canCreate && (
          <>
            <IconButton style={{ width: 40 }} onClick={onClick}>
              <Tooltip TransitionComponent={Zoom} title="Core Last Update">
                <Create />
              </Tooltip>
            </IconButton>
            {props.isShowSendReplacementWaitingButton && (
              <ConfirmButton
                {...props}
                variant="text"
                style={{ width: 40 }}
                size="medium"
                click={handleSendReplacementWaiting}
              >
                <Tooltip TransitionComponent={Zoom} title="Send Replacement Pending">
                  <Send />
                </Tooltip>
              </ConfirmButton>
            )}
            {props.isShowReserveForm && (
              <IconButton style={{ width: 40 }} onClick={handleReserveOpen}>
                <Tooltip TransitionComponent={Zoom} title="Component Reserve Form">
                  <AddToQueue />
                </Tooltip>
              </IconButton>
            )}

            {props.record.requestStatus == RequestStatus.CancellationRepairPeriod && <SendPreviousStatus {...props} />}
          </>
        )}
        <IconButton style={{ width: 40 }} onClick={handleShowWorkflow}>
          <Tooltip TransitionComponent={Zoom} title="Show Workflow">
            <AccountTree />
          </Tooltip>
        </IconButton>
      </ButtonGroup>
    </Box>
  );
};

export default ListCustomButtons;
